import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ILocation } from 'interfaces';
import { LoadState } from 'enums';
import { Loader } from 'components';

interface ILocationItemProps {
    location: ILocation
    isChecked: boolean,
    className: string,
    onSelectLocation: (l: ILocation) => void,
    onPingLocation: (l: ILocation[]) => void,
}

export const LocationItem: FunctionComponent<ILocationItemProps> = ({ onPingLocation, onSelectLocation, location, isChecked, className }) => {

    return (
        <li className={className} key={location.number}>
            <div className="locationsItem_checkCol locationsItem_col">
                <div className="locationsItem_checkCircle">
                    <input 
                        name={location.number}
                        type="checkbox"
                        className="locationsItem_check" 
                        onChange={() => onSelectLocation(location)}
                        checked={isChecked}
                    />
                </div>
            </div>
            <div className="locationsItem_modalLink">
                <div className="locationsItem_iconCol locationsItem_col">
                    <div className="locationsItem_iconCircle">
                        <FontAwesomeIcon icon="map-marker" className="locationsItem_icon" />
                    </div>
                </div>
                <div className="locationsItem_makeModelCol locationsItem_col">
                    <div className="locationsItem_manufacturer ellipsis" title={location.number}>
                        {location.number}
                    </div>
                    <div className="locationsItem_model ellipsis" title={location.name}>
                        {location.name}
                    </div>
                </div>

            </div>
            {location.pingStatus != LoadState.Loading && <Link
                to={'/locations'}
                onClick={() => onPingLocation([location])}
                className="locationsItem_editCol"
            >
                <FontAwesomeIcon icon="bell" className="locationsItem_editIcon" />
            </Link>}

            {location.pingStatus == LoadState.Loading && <Link
                to={'/locations'}
                onClick={e => e.preventDefault()}
                className="locationsItem_editCol"
            >
                <Loader />
            </Link>}


        </li>
    );
}
